import { Image, Button, Tooltip } from '@bfe/moly';
import { useFm, useScreenType, useToast } from '@web3/base-hooks';
import {
  publicAssetsPath,
  formatKMB,
  thousandsSeparator,
  WalletType,
} from '@web3/base-utils';
import { useConnectWalletModal } from '@web3fe/infra';
import Line from '@/components/Line';
import clsx from 'clsx';
import { useEffect } from 'react';
import styles from './style.module.scss';
import useHomeStore from '@/store/home';
import { useWallet } from '@/hooks/wallet';
import { pointsTypes } from '@/config';
import { HelpIcon } from '@bfe/moly-icons';
import { PointsType } from '@/types';
import { PointsHistoryButton } from './PointsHistory';

export const Banner = () => {
  const fm = useFm();
  const connectWallet = useConnectWalletModal();
  const { toastFail } = useToast();
  const { isMobile } = useScreenType();

  const { walletId, walletType, supportWsotTask } = useWallet();
  const {
    fetchWalletStat,
    fetchWalletTotalPoints,
    fetchWalletTypePoints,
    walletStat,
    walletTotalPoints,
  } = useHomeStore();

  useEffect(() => {
    fetchWalletStat();
  }, []);
  useEffect(() => {
    if (supportWsotTask && walletId) {
      fetchWalletTotalPoints({
        walletId,
        walletType,
      });
      fetchWalletTypePoints({
        walletId,
        walletType,
        type: walletType === WalletType.CLOUD ? PointsType.wsot : pointsTypes,
      }).then((res) => {
        if (!res?.success) {
          toastFail(res.message);
        }
      });
    }
  }, [supportWsotTask, walletId, walletType]);
  return (
    <div className={styles['home-banner']}>
      <div
        className={clsx(
          'main flex justify-between',
          isMobile ? 'flex-col-reverse items-center' : 'gap-20'
        )}
      >
        <div
          className={clsx(
            isMobile ? 'px-4 relative -top-6 items-center' : '', //pt-14 pb-6
            'flex flex-col gap-10 justify-center'
          )}
        >
          <div>
            <h1
              className={clsx(
                isMobile ? 'text-3hxl text-center' : 'text-[56px]',
                'font-semibold'
              )}
            >
              Web3 Points
            </h1>
            <p
              className={clsx(
                isMobile ? 'text-lg leading-[26px] font-normal' : 'text-xl',
                'mt-2'
              )}
            >
              {fm('earnWeb3Points')}
            </p>
          </div>
          <div
            className={clsx(
              isMobile
                ? 'w-[60.4%] mt-6 flex flex-col items-center'
                : 'w-[300px]'
            )}
          >
            <div className="flex gap-10 items-center">
              <div>
                <p className="text-xs text-gray-t2">
                  {fm('distributedPoints')}
                </p>
                <div className="text-3xl mt-1 font-semibold">
                  {formatKMB(walletStat?.totalPoint) || 0}
                </div>
              </div>
              <Line height={27.019} />

              <div>
                <p className="text-xs text-gray-t2">
                  {fm('participatedUserNum')}
                </p>
                <div className="text-3xl mt-1 font-semibold">
                  {formatKMB(walletStat?.totalWalletId) || 0}
                </div>
              </div>
            </div>
            {!supportWsotTask && (
              <Button
                variant={'primary'}
                size={isMobile ? 'small' : 'large'}
                className={clsx(
                  isMobile ? 'text-sm !h-10' : 'text-lg',
                  'font-semibold w-full mt-4' // bg-brand  text-white
                )}
                onClick={() => connectWallet.show()}
              >
                {fm('joinImmediately')}
              </Button>
            )}
          </div>
        </div>
        <div className="w-[530px] h-[365px] relative right-4">
          <Image
            className={clsx(
              'absolute top-0 -right-18',
              isMobile
                ? 'w-[38.8%]'
                : 'h-[365px] transform scale-105 translate-y-4 -translate-x-16'
            )}
            src={publicAssetsPath('/png/upcoming/banner.png')}
            alt=""
          />
          {supportWsotTask && (
            <div className={styles['my-dashboard']}>
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold">{fm('myPoints')}</h2>
                <PointsHistoryButton />
              </div>
              <Line
                className="my-4"
                width={450}
                color="rgba(255, 255, 255, 0.15)"
              />
              <div
                className={clsx(
                  'flex justify-between',
                  styles['my-dashboard-info']
                )}
              >
                <div className="flex flex-col">
                  <span
                    className="value text-4hxl "
                    // onClick={() => setShowHistory(true)} cursor-pointer
                  >
                    {thousandsSeparator(walletTotalPoints?.point as number)}
                    {/* <DirectionrightIcon
                      style={{
                        width: 24,
                        height: 24,
                        marginLeft: 4,
                      }}
                    /> */}
                  </span>
                  <span className="label flex items-center gap-1 text-gray-t2">
                    {fm('pointsEarned')}
                    <Tooltip title={fm('pointsExplainContent')}>
                      <HelpIcon className="cursor-pointer" />
                    </Tooltip>
                  </span>
                </div>
                <div className="flex flex-col justify-end">
                  <span className="value flex items-baseline gap-2">
                    <span className="text-4hxl font-semibold">
                      {walletTotalPoints?.rankRate
                        ? `${walletTotalPoints?.rankRate}%`
                        : '-'}
                    </span>
                    <span className="text-2hxl font-semibold">Top</span>
                  </span>
                  <span className="label text-right text-gray-t2">
                    {fm('myRanking')}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
